import KendoWindowMixin from './KendoWindowMixin'

export default {
    name: 'kendo-window',
    mixins: [ KendoWindowMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/index.js